<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <div style="text-align: left">
            {{ apParagraphOne }}
          </div>
        </v-row>
        <v-row class="pa-3">
          <div style="text-align: left">
            {{ apParagraphTwo }}
          </div>
        </v-row>
        <ProductCardSubscriptionRow :is-subscribed="isSubscribed" :name="product.name" />
        <v-row v-if="isSubscribed" class="pa-3">
          {{ isSubscribedLoginText }}
        </v-row>
        <v-row v-else class="pa-3">
          {{ notSubscribedLoginText }}
        </v-row>
        <template v-if="isSubscribed">
          <v-row class="pa-3">{{ disableUserText }}</v-row>
          <v-row class="pa-3">
            To disable your entire agency's access to Agent Portal,<v-btn text x-small color="#1976d2" @click="unsubscribe()">click here</v-btn>
          </v-row>
        </template>
        <template v-else>
          <v-row justify="center" align="center">
            <v-btn color="#FF9E15" :loading="loading" :disabled="!agreedToTerms" @click="subscribe()">Subscribe</v-btn>
          </v-row>
          <v-row justify="center" align="center">
            <v-checkbox v-model="agreedToTerms" :label="checkboxLabel" />
          </v-row>
        </template>
        <v-row v-if="error" color="red">{{ error }}</v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="px-3">
          <v-col cols="3" class="text-left">
            <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import ProductCardSubscriptionRow from '@/components/products/shared/ProductCardSubscriptionRow';

export default {
  name: 'AgentPortal',
  components: {
    ProductCardSubscriptionRow,
    ProductCardHeader
  },
  mixins: [productIdMappingMixin],
  data () {
    return {
      apParagraphOne: 'HawkSoft Agent Portal gives your agency freedom to view client data from a web browser on any mobile device —  smartphone, tablet, or laptop. Whether you’re at lunch with a prospect or on the road headed to an insured’s home or place of business, Agent Portal brings details like contact information, policy data, and coverages to your fingertips.',
      apParagraphTwo: 'You control which employees have access to client data outside the office. Agency managers can set permissions conveniently located in the HawkSoft User List.',
      disableUserText: 'If you wish to disable specific users from accessing agent portal, adjust permissions in the user list for those users.',
      checkboxLabel: 'Agent Portal is intended for use by your agency\'s licensed Seats to HawkSoft CMS',
      isSubscribedLoginText: 'Log in at https://agent.hawksoft.cloud using your HawkSoft CMS credentials.',
      notSubscribedLoginText: 'Enable HawkSoft Agent Portal today, and log in at https://agent.hawksoft.cloud using your HawkSoft CMS credentials.',
      agreedToTerms: false,
      loading: false,
      error: null
    };
  },
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('agentPortal'));
    },
    isSubscribed () {
      if (this.product) {
        return this.product.isSubscribed;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setProductSubscription']),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    async subscribe () {
      this.loading = true;
      var rs = await this.$api.setSubscriptionDetailed(this.product.id, true, null, true);
      if (rs.code !== 0) {
        this.error = 'An error has occurred, please try again shortly, or contact HawkSoft support for assistance';
        this.loading = false;
        return;
      }
      this.error = null;
      this.setProductSubscription({ productId: this.product.id, subscription: true });
      this.loading = false;
    },
    async unsubscribe () {
      this.loading = true;
      try {
        await this.$api.setSubscriptionDetailed(this.product.id, false, null, true);
      } catch (error) {
        this.error = 'An error has occurred, please try again shortly, or contact HawkSoft support for assistance';
        return;
      }

      this.error = null;
      this.setProductSubscription({ productId: this.product.id, subscription: false });
      this.loading = false;
    }
  }
};
</script>
